import {MasterDataRepository} from "@/modules/masterData/adapter/MasterDataRepository";

export class MasterDataPort implements MasterDataRepository{
    private readonly masterDataRepository: MasterDataRepository;

    constructor(params: { masterDataRepository: MasterDataRepository }) {
        this.masterDataRepository = params.masterDataRepository;
    }
    public getGridList():any[] {
        return this.masterDataRepository.getGridList();
    }

    public async set_BestandslistenArtikel(id:number,ids:number[]): Promise<void> {
        return this.masterDataRepository.set_BestandslistenArtikel(id,ids);
    }

    public async del_BestandslistenArtikel(id:number,ids:number[]): Promise<void> {
        return this.masterDataRepository.del_BestandslistenArtikel(id,ids);
    }
}
